import type { ListBuilderList } from '../../../types';
import { createQuoteShopStandardColumns } from '../columns';
import {
	QUOTE_SHOP_MOBILE_CARD_CONFIG,
	QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
} from '../shared';

/**
 * Quote Shop At Risk list configuration
 * At-risk items for the quote shop
 */
export const quoteShopAtRiskList: ListBuilderList = {
	id: 'quote_shop_at_risk',
	cacheTTL: 600000,
	name: 'At Risk',
	type: 'default',
	active: true,
	sortOrder: 2,
	columns: createQuoteShopStandardColumns(),
	description: 'At-risk items for the quote shop',
	defaultSortId: 'in_stock_first',
	requiredFields: QUOTE_SHOP_STANDARD_REQUIRED_FIELDS,
	mobileCardConfig: QUOTE_SHOP_MOBILE_CARD_CONFIG,
	filterRules: {
		item_filters: {
			defaultValue: [
				{
					id: 'in_stock',
					label: 'In Stock',
				},
				{
					id: 'at_risk',
					label: 'At Risk',
				},
			],
		},
	},
};
